import { useEventListener } from "./useEventListener";

export const useKeyDown = (keyCode, action, props) => {
  useEventListener(
    "keydown",
    (e) => e.keyCode === keyCode && action(e, props),
    props
  );
};
